"use strict";
(function groupingPlugin(global) {

  //TODO: Шамов А.: В целом не понятно как она работает. Часть функций в гриде часть тут. Надо бы как-то сделать понятнее, например максимально перенести из грида сюда. 

  /**
    * Плагин для группировки в таблице.
    *
    * @class WebAccess.components.dataViews.gridPlugins.GroupingPlugin
    * @extends WebAccess.Plugin
    * @property {string} name Имя пункта меню.
    * @property {string} grid Таблица.
    * @since 5.2.0.1100
    */
  global.GroupingPlugin = WA.Plugin.extend({
    name: 'GroupingPlugin',
    _grid: null,
    _oldGrouping: null,

    _groupItemMetadataProvider: null,

    /**
    * Регистрирует плагин.
    *
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#register
    * @param {grid} Таблица
    * @since 5.2.0.1100
    * @return {object} Ассоциативный массив, содержащий публичные методы.
    */
    register: function (grid) {
      var me = this;
      me._super();
      me._grid = grid;

      me._groupItemMetadataProvider = new Slick.Data.GroupItemMetadataProvider();

      var E = WA.CMP.DV.Grid.EVENT;
      grid.bind(E.BEFORE_GRID_INIT, $.proxy(me._onGridBeforeInit, me));
      grid.bind(E.GRID_INIT, $.proxy(me._onGridInit, me));
      grid.bind(E.COLUMN_INIT, $.proxy(me._onColumnInit, me));
      grid.bind(E.GET_VISIBLE_COLUMNS_FOR_DIALOG, $.proxy(me._onGetVisibleColumnsForDialog, me));
      grid.bind(E.SET_VISIBLE_COLUMNS_FROM_DIALOG, $.proxy(me._onSetVisibleColumnsFromDialog, me));
      grid.bind(E.AFTER_DATA_LOADED, $.proxy(me._onAfterDataLoaded, me));

      return {
        'unGroupColumnsById': me._unGroupColumnsById_exported,
        'updateGroupingInfo': me._updateGroupingInfo_exported,
        'toogleGrouping': me._toogleGrouping_exported
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Модификация видимых колонок грида для отображения колонок с группировкой.
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_onGetVisibleColumnsForDialog
    * @since 5.2.0.1100
    * @private    
    */
    _onGetVisibleColumnsForDialog: function (columns) {
      var me = this;
      me._includeGroupedColumns(columns);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Модификация видимых колонок грида для разгруппировки и задания видимых колонок.
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_onGetVisibleColumnsForDialog
    * @since 5.2.0.1100
    * @private    
    */
    _onSetVisibleColumnsFromDialog: function (columns) {
      var me = this;
      me._excludeGroupedColumns(columns);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Разгруппировка списка колонок.
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_unGroupColumnsById_exported
    * @since 5.2.0.1100
    * @private    
    */
    _unGroupColumnsById_exported: function (columnIds) {
      var me = this;
      var grouping = _(me.state.GroupColumns).map(function (column) {
        if (columnIds.indexOf(column.Name) !== -1) {
          var selector = '#' + me.grid.getUID() + column.Name;
          selector = selector.replaceAll(' ', '\\ ');
          $(selector).remove();
          me.dataView.removeGroupBy(column.Name);
          return null
        } else {
          return column;
        }
      });

      me.updateState({ GroupColumns: _(grouping).compact() });
      me.reloadData();
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Начальная модификация колонок грида для поддержки группировки
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_onColumnInit
    * @since 5.2.0.1100
    * @private    
    */
    _onColumnInit: function (byref_column) {
      var isSpecialColumn = (byref_column.id.charAt(0) === '_');
      byref_column.type === 'Date'
      var isFloatColumn = (byref_column.type === 'Float');

      byref_column.headerCssClass = (isSpecialColumn ? 'notDraggable' : ''); // Отключяем группировку по реквизиту типа "Дробное число", т.к. делать сравнение 2 дробных чисел сложно.

      if (!isSpecialColumn) {
        byref_column['grouping'] = {
          getter: byref_column.id,
          formatter: function (g) {
            return byref_column.name + ": " + g.rows[0][byref_column.field];
          },
          comparer: function (g1, g2) {
            var direction = byref_column.grouping.sortAsc ? 1 : -1;
            // Сравнивает по отображаемому значению.
            var v1 = g1.rows[0][byref_column.field];
            var v2 = g2.rows[0][byref_column.field];
            
            return direction * WA.utils.compareData(v1, v2, byref_column.type)
          },
          collapsed: true,
          sortAsc: true
        };
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установка дополнительных опции грида. Поскольку это событие, то приходится менять объект по ссылке.
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_onGridBeforeInit
    * @since 5.2.0.1100
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.GroupingPlugin} GroupingPlugin
    */
    _onGridBeforeInit: function (containerSelector, byref_dataView, columns, byref_options) {
      byref_options['enableDraggableGroupBy'] = true;
      byref_dataView['groupItemMetadataProvider'] = this._groupItemMetadataProvider;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Метод срабатывает после создания экземпляра slickGrid-а в классе грида. 
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_onGridInit
    * @param {slickGrid} объект грида    
    * @since 5.2.0.1100
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.GroupingPlugin} GroupingPlugin
    */
    _onGridInit: function (slickGrid) {
      var me = this;
      log.debug('GRID', 'onGridInit method called');

      // register the group item metadata provider to add expand/collapse group handlers
      me._grid.grid.registerPlugin(this._groupItemMetadataProvider);

      //При пермещении колонок в области группировки обновляем состояние в соответсвии с новым порядком колонок
      me._grid.grid.onColumnsReordered.subscribe(function () {
        log.debug('GRID', 'Event onColumnsReordered emited(GROUPING_PLUGIN)');
        var grouping = me._getGrouping();
        var newGrouping = _(grouping).pluck('Name');

        log.debug('GRID', 'Updating columns grouping');

        /**        
        * Если группировка изменилась, то будем сворачивать расскрытые группы и 
        * обновим саму группировку в state.
        * Иначе ничего не меняем, чтобы смена местами обычных колонок (не группируемых) работала 
        * не сворачивая групп        
        * @see #97566 Если поменять колонки местами при раскрытой группе в гриде, то группа закроется
        */
        if (!_.isEqual(newGrouping, me._oldGrouping)) {
          me._grid.updateState({ GroupColumns: grouping });
          me._grid.dataView.collapseAllGroups();
          me._grid.reloadData();
        }

        me._oldGrouping = newGrouping;
      });

      // Событие разгруппировки.
      me._grid.grid.onUnGroup.subscribe(function (event, data) {
        log.debug('GRID', 'Event onUnGroup emited');
        var jColumn = data.column;
        var columnId = jColumn.find('span').attr('name');
        me._grid.dataView.removeGroupBy(columnId, null, jColumn);
        var index = $('.slick-header-columns div.slick-header-column', me._grid.containerSelector).index(jColumn);
        me._grid.showColumn(columnId, index);
      });

      // Смена сортировки по колонке с группировкой.
      me._grid.grid.onGroupSort.subscribe(function (e, args) {
        log.debug('GRID', 'Event onGroupSort emited');
        var prevGrouping = me._grid.state.GroupColumns;
        var groupCol = _(prevGrouping).findWhere({ Name: args.columnId });
        groupCol.SortIsAsc = args.sortAsc;

        me._grid.updateState({ GroupColumns: prevGrouping }, true); //true - потому изменяется объект по ссылке и сравнение внутри updateState не корректно сработает.
        me._grid.reloadData();
      });

      me._restoreGrouping();
      me._handleGroupToggle();
      me._oldGrouping = _(me._getGrouping()).pluck('Name');

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Востановление группировки при перезагрузке страницы    
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_restoreGrouping
    * @since 5.2.0.1100
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.GroupingPlugin} GroupingPlugin
    */
    _restoreGrouping: function () {
      log.debug('GRID', 'Restoring grouping');
      var me = this;

      /**
      * Показ скрытие области группировки
      */
      me._grid.toogleGrouping(me._grid.state.IsGroupPanelVisible);

      /**
      * Восстановление представления шапки и логической группировки грида
      */
      me._grid.dataView.setGrid(me._grid.grid);
      if (me._grid.state.GroupColumns) {

        // #97328 Если не стало прав на реквизит, по которому идет группировка, то грид ломается
        var shrinked = _(_(me._grid.state.GroupColumns).map(function (column) {
          var gridColumn = _(me._grid._columns).findWhere({ 'id': column.Name });
          if (!!gridColumn) return column;
          else return null;
        })).compact();

        var columns = _(shrinked).map(function (column) {
          var gridColumn = _(me._grid._columns).findWhere({ 'id': column.Name });
          // Восстановление направления сортировки по группе.
          gridColumn.grouping.sortAsc = column.SortIsAsc
          return gridColumn;
        });

        me._grid.dataView.restoreGroupedColumns(columns);
      }

      /**
      * Восстановление раскрытых строк
      */
      _(me._grid.state.GroupColumns).each(function (column, level) {
        _(column.Opened).each(function (chain) {
          me._grid.dataView.expandCollapseGroup(level, chain, false);
        });
      });

      me._setupGroupsReordering();
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**    
    * Обработка раскрытия групп.    
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_handleGroupToggle
    * @since 5.2.0.1100        
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.GroupingPlugin} GroupingPlugin
    */
    _handleGroupToggle: function () {
      var me = this;
      me._grid.dataView.prepareDataBeforeToggle = function (groupingKey, isCollapsed) {
        me._grid.updateGroupingInfo(groupingKey, isCollapsed);
        let options = { isClickOnToggle: true };
        return me._grid.reloadData(options);
      };
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Реализация возможности изменения порядка колонок, по которым идет группировка
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_setupGroupsReordering
    * @private
    * @since 5.2.0.1100 
    * @return {WebAccess.components.dataViews.gridPlugins.GroupingPlugin} GroupingPlugin
    */
    _setupGroupsReordering: function () {
      log.debug('GRID', 'Groups sorting setup');
      var me = this;

      $('.slick-groupby').sortable({
        containment: me._grid.containerSelector,
        connectWith: ".connected",
        cursor: 'move',
        tolerance: "pointer",
        distance: 20,
        cancel: '.slick-placeholder, .group-arrow',
        placeholder: "slick-sortable-placeholder ui-state-default slick-header-column",
        forcePlaceholderSize: true,
        stop: function (event, element) {
          me._grid.dataView.beginUpdate();
          me._grid.dataView.resortGroupColumns();
        },
        receive: function (event, ui) {

          // Группировка - перенос из шапки грида в область группировки.
          if (ui.item.hasClass('notDraggable')) {
            $(ui.sender).sortable('cancel');
            var toast = new WA.CMP.NTF.Toast();
            toast.showWarning(L('GROUPING_IS_NOT_AVAILABLE_FOR_THIS_COLUMN'));
            return;
          };

          me._grid.updateState({ "PageIndex": 0 });

          var jColumn = $(ui.item);
          var columnId = jColumn.find('span').attr('name');
          var index = $('.slick-groupby div.slick-header-column', me._grid.containerSelector).index(jColumn);

          // Смотрим какая была сортировка у этой колонки, что бы её применить в группе.
          var sortColumnInfo = _(me._grid.state.Sort).findWhere({ Name: columnId });
          var column = _(me._grid._columns).findWhere({ id: columnId });
          column.grouping.sortAsc = (!sortColumnInfo || sortColumnInfo.IsAsc);

          me._grid.dataView.handleGroupByDrop($(), ui.item, index);
          me._grid.dataView.bindGroupSort(jColumn, me._grid._columns);

          jColumn.css({ 'width': 'auto' });
          me._grid.hideColumn(columnId);
        }
      });

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение информации о группировке от грида, и выдача его в виде
    * пригодном для сохранения в state
    * @private
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#getGrouping
    * @return {array} groups
    */
    _getGrouping: function () {
      var me = this;

      var groups = _(me._grid.dataView.getGrouping()).map(function (col) {
        return {
          Name: col.getter,
          SortIsAsc: col.sortAsc,
          Opened: []
        };
      });

      me._updatePlaceHolder(groups.length);
      return groups;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать/скрыть текст-подсказку в области группировки
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_updatePlaceHolder
    * @param {int} groupsCount кол-во групп
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.GroupingPlugin} GroupingPlugin
    */
    _updatePlaceHolder: function (groupsCount) {
      var me = this;
      if (groupsCount > 0) {
        $(".slick-placeholder", me._grid.containerSelector).hide();
      } else {
        $(".slick-placeholder", me._grid.containerSelector).show();
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Метод вызывается внешним классом groupitemmetadataprovider, для того, 
    * чтобы обновить информацию по сворачиванию/разворачиванию определенных групп
    * для дальнейшего сохранения в обеъект state;
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#updateGroupingInfo_exported
    * @param {String} groupingKey ключ вида "123213:|:323423" - иерархия раскрытия групп
    * @param {isExpand} призна того раскрывается группа или сворчивается
    * @this {WebAccess.components.dataViews.Grid}
    * @since 5.2.0.1100
    * @private
    * @return {WebAccess.components.dataViews.Grid}
    */
    _updateGroupingInfo_exported: function (groupingKey, isExpand) {
      log.debug('GRID', 'Updating grouping info: ' + groupingKey);
      var me = this;
      var values = groupingKey.split(':|:');
      var lastIndex = values.length - 1;

      var currentGrouping = me.state.GroupColumns;
      if (isExpand) {
        currentGrouping[lastIndex].Opened.push(groupingKey);
      } else {
        var index = currentGrouping[lastIndex].Opened.indexOf(groupingKey);
        currentGrouping[lastIndex].Opened.splice(index, 1);
      }

      me.updateState({
        GroupColumns: currentGrouping,
        LastCollapsedGroupingKey: (!isExpand ? groupingKey : '__NOT_KEY__')
      }, true);
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Событие после загрузки данных.
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_onAfterDataLoaded
    * @since 5.2.0.1100
    * @private
    * @return {WebAccess.components.dataViews.gridPlugins.GroupingPlugin} GroupingPlugin
    */
    _onAfterDataLoaded: function () {
      // Сбрасываем последную закрытую группу.
      this._grid.updateState({
        LastCollapsedGroupingKey: '__NOT_KEY__'
      });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показ/скрытие области группировки
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#toogleGrouping_exported
    * @this {WebAccess.components.dataViews.Grid}
    * @since 5.2.0.1100
    * @private
    * @return {WebAccess.components.dataViews.Grid}
    */
    _toogleGrouping_exported: function (needToEnable) {
      log.debug('GRID', 'Toggling group area: ' + needToEnable);
      var me = this;
      var jPHolder = $('.slick-placeholder', me.containerSelector);
      var jGroupBy = $('.slick-groupby', me.containerSelector);

      jPHolder.text(L('DRAG_A_COLUMN_HEADER_HERE_TO_GROUP_BY_THAT_COLUMN'));
      if (me.state.GroupColumns.length) {
        jPHolder.hide();
      } else {
        jPHolder.show();
      }

      if (needToEnable) {
        jGroupBy.show();

        me.grid.setOptions({
          showGroupByRow: true,
          groupByRowHeight: jGroupBy.outerHeight()
        });
        me.grid.resizeViewport();
        me.updateState({ IsGroupPanelVisible: true }, true);
      } else {
        jGroupBy.hide();

        me.grid.setOptions({ showGroupByRow: false });
        me.grid.resizeViewport();
        me.updateState({ IsGroupPanelVisible: false }, true);
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Включает группы в список видимых колонок для диалога.
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_includeGroupedColumns
    * @this {WebAccess.components.dataViews.Grid}
    * @since 5.2.0.1100
    * @private
    * @return {WebAccess.components.dataViews.Grid}
    */
    _includeGroupedColumns: function (byref_visibleColumns) {
      var me = this;

      _(me._grid.state.GroupColumns).each(function (groupInfo) {
        var column = _(me._grid._columns).find(function (col) {
          return col.id === groupInfo.Name;
        });
        byref_visibleColumns.push(column);
      });

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Исключает группы из списока видимых колонок и разгруппировывает группы.
    * @method WebAccess.components.dataViews.gridPlugins.GroupingPlugin#_excludeGroupedColumns
    * @this {WebAccess.components.dataViews.Grid}
    * @since 5.2.0.1100
    * @private
    * @return {WebAccess.components.dataViews.Grid}
    */
    _excludeGroupedColumns: function (byref_visibleColumns) {
      var me = this;
      var unGroupingColumns = [];

      _(me._grid.state.GroupColumns).each(function (groupInfo) {

        // Ищем групп в списке возвращенных видимых колонок.
        var index = _(byref_visibleColumns).findIndex(function (visibleColumn) {
          return visibleColumn.id === groupInfo.Name;
        });
        if (index !== -1) {
          // Если нашли, то просто удаляем её из видимых колонок.
          byref_visibleColumns.splice(index, 1);
        } else {
          // Если НЕ нашли, то добавляем в список разгруппируемых.
          unGroupingColumns.push(groupInfo.Name);
        }
      });

      // Выполняем разгруппировку.
      me._grid.unGroupColumnsById(unGroupingColumns);

      return me;
    }

  });

})(WA.components.dataViews.gridPlugins);